/* Shared state between all Vue instances, using Vuex */
import Vue from "vue";
import Vuex from "vuex";
import productDisplay from "./modules/product-display";
import productDetail from "./modules/product-detail";
import searchMenu from "./modules/search-menu";
import videoModal from "./modules/video-modal";
import compareModal from "./modules/compare-modal";
import notifications from "./modules/notifications";
import gtmStore from "./modules/gtm-store";
import virtualTray from "./modules/virtual-tray";
import searchResultsPage from "./modules/search-results-page";
import filters from "./modules/filters";
import inspirationPage from "./modules/inspiration-page";
import basketPage from "./modules/basket-page";
import checkoutPage from './modules/checkout-page'
import benjaminMoore from "./modules/benjamin-moore";
import myTray from "./modules/my-tray";
import myProject from "./modules/my-project";
import contentWizard from "./modules/content-wizard";
import trimsAccessories from "./modules/trims-accessories";
import newBasketPage from "./modules/new-basket-page";
import newCheckoutPage from "./modules/new-checkout-page";

Vue.use(Vuex);

// Export the store
export default new Vuex.Store({
  modules: {
    productDisplay,
    productDetail,
    searchMenu,
    videoModal,
    compareModal,
    notifications,
    gtmStore,
    virtualTray,
    searchResultsPage,
    filters,
    checkoutPage,
    inspirationPage,
    benjaminMoore,
    basketPage,
    myTray,
    myProject,
    contentWizard,
    trimsAccessories,
    newBasketPage,
    newCheckoutPage
  }
});
